import { render, staticRenderFns } from "./BarraNavegacao.vue?vue&type=template&id=b01bfde2&scoped=true"
import script from "./BarraNavegacao.vue?vue&type=script&setup=true&lang=js"
export * from "./BarraNavegacao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BarraNavegacao.vue?vue&type=style&index=0&id=b01bfde2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01bfde2",
  null
  
)

export default component.exports